/**
 * Hook de datos del **grid del talonario ACTUAL** de un trabajador
 * (`GET /api/v1/talonarios/<worker>/grid`).
 *
 * Datos de servidor -> TanStack Query. La query key incluye la sede activa y el
 * trabajador. La red la gobierna `lib/api` (cookie httpOnly + `X-Sede-Id`). Con
 * `worker` vacío la query queda inactiva (`enabled`), evitando una llamada sin
 * destino.
 */
import { useQuery } from "@tanstack/react-query";

import { getActiveSedeId } from "@/lib/sede";

import { fetchTalonarioGrid } from "../api";
import type { TalonarioGrid } from "../types";
import { talonarioGridQueryKey } from "./queryKeys";

export function useTalonarioGrid(worker: string) {
  const sedeId = getActiveSedeId();
  return useQuery<TalonarioGrid>({
    queryKey: talonarioGridQueryKey(sedeId, worker),
    queryFn: () => fetchTalonarioGrid(worker),
    enabled: worker.length > 0,
    staleTime: 15_000,
  });
}
